/**
 * @generated SignedSource<<8ca5eb6505f55b58062c78b13ee0c42f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useTrustpilotReviewMutation$variables = {};
export type useTrustpilotReviewMutation$data = {
  readonly userConsentedToFeedback: string | null;
};
export type useTrustpilotReviewMutation = {
  variables: useTrustpilotReviewMutation$variables;
  response: useTrustpilotReviewMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userConsentedToFeedback",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTrustpilotReviewMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTrustpilotReviewMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ca4fded6a474738155d22a2c5ab3accd",
    "id": null,
    "metadata": {},
    "name": "useTrustpilotReviewMutation",
    "operationKind": "mutation",
    "text": "mutation useTrustpilotReviewMutation {\n  userConsentedToFeedback\n}\n"
  }
};
})();

(node as any).hash = "14d3e2ffeb334cf691db0bd9f29e3f9f";

export default node;
